import { render, staticRenderFns } from "./TablaPrioridadByOd.vue?vue&type=template&id=0e5855c8&scoped=true"
import script from "./TablaPrioridadByOd.vue?vue&type=script&lang=js"
export * from "./TablaPrioridadByOd.vue?vue&type=script&lang=js"
import style0 from "./TablaPrioridadByOd.vue?vue&type=style&index=0&id=0e5855c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5855c8",
  null
  
)

export default component.exports